'use client';

import { DataTableFacetedFilter } from './data-table-faceted-filter';

export function DataTableToolbar({ table, facetedFilters = [] }) {
  const isFiltered = table.getState().columnFilters.length > 0;
  return (
    <div className="w-full">
      <div className="flex items-center space-x-2 overflow-x-auto sm:flex-wrap sm:overflow-visible">
        {facetedFilters.map(({ columnId, title, options }) => {
          const column = table.getColumn(columnId);
          return column ? (
            <DataTableFacetedFilter
              key={columnId}
              column={column}
              title={title}
              options={options}
            />
          ) : null;
        })}

        {/* Optional reset button if filters are active */}
        {/* 
        {isFiltered && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => table.resetColumnFilters()}
          >
            Reset
            <X className="ml-1 h-4 w-4" />
          </Button>
        )} 
        */}
      </div>
    </div>
  );
}
